import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-html-icon',
  templateUrl: './documents-html.component.html'
})
export class DocumentsHtmlComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
